import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { runtimeConfig } from '@/config/runtimeConfig';
import { AppError } from '@/lib/errors';

let cached: SupabaseClient | null = null;

/** The shared Supabase client, created from runtime env. */
export function supabase(): SupabaseClient {
  if (cached) return cached;
  const { supabaseUrl, supabaseAnonKey } = runtimeConfig;
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new AppError(
      'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.',
      'VALIDATION',
    );
  }
  cached = createClient(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: true, autoRefreshToken: true },
  });
  return cached;
}
